import DashBoardNav from '@/layout/DashBoardNav'

export default [{
  path: '/dashboard',
  component: DashBoardNav,
    children: [{
      path: '/dashboard',
      component: () => import('@/components/home/dashboard')
    }
  ]
}]
